import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import { FormattedHTMLMessage } from 'react-intl'
import uuid from 'uuid'
import styles from './radio.styl'

export default class Radio extends Component {
  static propTypes = {
    disabled: PropTypes.bool,
    horizontal: PropTypes.bool,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    value: PropTypes.any.isRequired,
    name: PropTypes.string.isRequired,
    intlKey: PropTypes.string
  }

  handleChange = field => {
    if (this.props.onChange) {
      this.props.onChange(Boolean(this.props.value))
    }
    field.input.onChange(Boolean(this.props.value))
  }

  renderField = field => {
    const { label, disabled, intlKey } = this.props
    const key = uuid.v1()
    const disabledClass = disabled ? ' disabled' : ''

    return (
      <div className={styles.controls}>
        <input
          className={`form-control ${styles.formControl}`}
          type="radio"
          {...field.input}
          value={this.props.value}
          id={key}
          checked={this.props.value === field.input.value}
          disabled={disabled}
        />
        <label
          htmlFor={key}
          className={`control-label ${styles.controlLabel} ${disabledClass}`}
        >
          {intlKey
            ? <FormattedHTMLMessage id={intlKey} defaultMessage={label} />
            : label}
        </label>
      </div>
    )
  }

  render() {
    const { horizontal, name } = this.props
    const horizontalClass = horizontal ? styles.horizontal : ''

    return (
      <div className={`${styles.formGroup} ${horizontalClass}`}>
        <Field name={name} component={this.renderField} />
      </div>
    )
  }
}
